import { atomWithReset } from 'jotai/utils';

import { splitViewGoToBarDefaultSettings } from './SplitViewGoToBar.constants';
import { SplitViewGoToBarSettingsState } from './SplitViewGoToBar.types';

export const splitViewGoToBarSettingsState = atomWithReset<SplitViewGoToBarSettingsState>(
    splitViewGoToBarDefaultSettings
);
